import { removeEmptySearchParams } from "../../utils";
import * as ROUTES from "../../Router/corporate_routes";
import {
  companyReceivedError,
  companyReceivedRequest,
  companyRequest,
} from "./company";
import {
  COMPANY_FILE_ERROR_REQUEST,
  COMPANY_FILE_RECEIVED_REQUEST,
  COMPANY_FILE_REQUEST,
  COMPANY_FILES_ERROR_REQUEST,
  COMPANY_FILES_RECEIVED_REQUEST,
  COMPANY_FILES_REQUEST,
} from "../reducers/types";
import axios from "axios";
export const companyFilesRequest = () => ({
  type: COMPANY_FILES_REQUEST,
});

export const companyFilesReceivedRequest = data => ({
  type: COMPANY_FILES_RECEIVED_REQUEST,
  data,
});

export const companyFilesErrorRequest = () => ({
  type: COMPANY_FILES_ERROR_REQUEST,
});

export const companyFileRequest = () => ({
  type: COMPANY_FILE_REQUEST,
});

export const companyFileReceivedRequest = data => ({
  type: COMPANY_FILE_RECEIVED_REQUEST,
  data,
});

export const companyFileErrorRequest = () => ({
  type: COMPANY_FILE_ERROR_REQUEST,
});

export const fetchCompanyFiles = (id, token) => {
  return dispatch => {
    dispatch(companyFilesRequest());
    return axios
      .get(
        window.API + ROUTES.API.COMPANY.FILES.LIST.replace(":companyId", id),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(response => {
        dispatch(companyFilesReceivedRequest(response));
      })
      .catch(error => dispatch(companyFilesErrorRequest(error)));
  };
};

export const uploadCompanyFile = (values, id, token) => {
  return dispatch => {
    dispatch(companyFileRequest());
    return axios
      .post(
        window.API + ROUTES.API.COMPANY.FILES.UPLOAD.replace(":companyId", id),
        values,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(response => dispatch(companyFileReceivedRequest(response)))
      .catch(error => dispatch(companyFileErrorRequest(error)));
  };
};

export const removeCompanyFile = (id, fileId, token) => {
  return dispatch => {
    dispatch(companyFileRequest());
    return axios
      .post(
        window.API +
          ROUTES.API.COMPANY.FILES.REMOVE.replace(":companyId", id).replace(
            ":fileId",
            fileId
          ),
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(response => dispatch(companyFileReceivedRequest(response)))
      .catch(error => dispatch(companyFileErrorRequest(error)));
  };
};
